module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "wrapper-transition",
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated slideOutDown",
      "appear": ""
    }
  }, [(_vm.allowNewsletterWidgetPopup) ? _c('div', {
    staticClass: "row no-gutters popup-wrapper"
  }, [_c('div', {
    staticClass: "close-icon-box d-flex align-items-center",
    on: {
      "click": _vm.closeNewsletter
    }
  }, [_c('svg-cancel-icon', {
    staticClass: "icon mx-auto",
    attrs: {
      "width": "100%",
      "height": "100%"
    }
  })], 1), _c('div', {
    staticClass: "col-12"
  }, [_vm._t("content")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57e8c72e","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/common/PopUpWrapper.vue
// module id = 1755
// module chunks = 1